<template lang="pug">
  .member-block(@click="buyMember")
    .member-left
      .member-title
        img(:src="getCardImage()")
      .member-info
        .member-top
          .member-top-left
            .member-top-left-title
              span {{ showTitle }}
            .member-top-left-word {{ showSubTitle }}
            .member-plus-img
              img.plus(src="https://m.hellobike.com/resource/gallery/61/wKDVGpeR_Group%201707482273.png?x-oss-process=image/quality,q_80")
        .member-middle()
          .member-animate(v-for="(item, index) in propertyDetailDTOS" :key="index"
          class="animation-member"
          :style="{ animationDelay: (-3 * index) + 's' }")
            .top-word
              .big-word {{item.amount }}
              .small-word {{ item.unit }}
            .bottom-word {{item.goodsPropDesc}}{{(item.goodsPropDesc==='次')?'卡':'券'}}
    .member-right
      .member-top-right
        .member-top-right-word
          .bule-big-word {{showBigMoney()}}
          .blue-small-word()
            span(v-if="showSmallMoney()") +{{differenceMoney}}
            span 元
        .line-word {{ moduleData.markedPrice }} 元
        .member-top-right-btn() 购买
  </template>

<script>
import { BikeRideCardImg, EbikeRideCardImg, OneCentRideCardImg } from '@/assets/imgAssets';
import { PropVersionMap } from '@/const/vip';
import {
  getNoScroll,
} from '@/utils';
import deepCopy from '@/utils/deepCopy';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { CouponMapper } from '../../utils';
import { ParamsUtil } from '../../../../../utils/params';

export default {
  props: {
    moduleData: {
      type: Object,
      default: () => { },
      // default() {
      //   return {
      //     usageRecords: [],
      //     markedPrice: null,
      //     signInfoDTO: {
      //       firstSignPrice: null,
      //       secondSignPrice: null,
      //     },
      //     tryingCardData: null,
      //   };
      // },
    },
    tryingCardData: {
      type: Object,
      default: () => { },
    },
    usageRecords: {
      type: Array,
      default() {
        return [];
      },
    },
    markedPrice: {
      type: Number,
      default() {
        return 0;
      },
    },
    signInfoDTO: {
      type: Object,
      default() {
        return {
          firstSignPrice: null,
          secondSignPrice: null,
        };
      },
    },
    rideMoneyData: {
      type: String,
      default: '',
    },
    newTabCode: {
      type: String,
      default: '',
    }
  },
  inject: ['rideOneCentVersion', 'newH5Version', 'latestTabCode'],
  data() {
    return {
      timer: null,
      differenceMoney: '',
      listData: [],
      propertyDetailDTOS: [],
      cardIndex: 0,
      // ClassMap: {
      //   0: { base: 'member-middle-code-one', animate: 'animate-1' },
      //   1: { base: 'member-middle-code-two', animate: 'animate-2' },
      //   2: { base: 'member-middle-code-three', animate: 'animate-3' },
      //   3: { base: 'member-middle-code-four', animate: 'animate-4' },
      // },
      currentIndex: 0,
      isAnimating: true,
      BikeRideCardImg,
      EbikeRideCardImg,
    };
  },
  computed: {
    tabCode() {
      return this.latestTabCode();
    },
    showTitle() {
      if (this.newH5Version()) {
        return this.newTabCode === 'bike' ? '单车30天不限次卡' : '助力车30天6次卡';
      }
      return this.tabCode === 'bike' ? '单车30天不限次卡' : '助力车30天6次卡';
    },
    showSubTitle() {
      if (this.newH5Version()) {
        return this.newTabCode === 'bike' ? '全国通用｜单笔抵120分钟' : '全国通用｜单笔抵3元';
      }
      return this.tabCode === 'bike' ? '全国通用｜单笔抵120分钟' : '全国通用｜单笔抵3元';
    },
  },
  mounted() {
    this.propertyDetailDTOS = deepCopy(this.moduleData.propertyDetailDTOS || []).splice(0, 4);
    this.propertyDetailDTOS.forEach((i) => {
      if (i.vipExtendProperty) {
        // eslint-disable-next-line no-param-reassign
        i.vipExtendProperty = null;
      }
    });
    this.propertyDetailDTOS = this.propertyDetailDTOS.map(CouponMapper);
    this.tryingCardDataInfo = this.tryingCardData;
    UBT.moduleExpose({
      pageId: 'platform_openedcard_page',
      categoryId: 'platform',
      moduleId: 'platform_buyVIP_button',
      contentId: 'platform_buyVIP_button',
      exposureTimes: 1,
      businessInfo: {},
    });
    this.listData = this.moduleData.usageRecords;
  },
  destroyed() {
    this.timer = null;
  },
  methods: {
    /**
     * 根据tabCode获取对应的卡片图片
     * @returns {string} 返回对应的图片URL
     */
    getCardImage() {
      // 优先判断：如果是一分骑版本，返回一分骑卡片图片
      if (this.rideOneCentVersion() === PropVersionMap.RIDE_ONE_CENT) {
        return OneCentRideCardImg;
      }
      if (this.newH5Version()) {
        // 根据tabCode返回对应的卡片图片
        return this.newTabCode === 'bike' ? this.BikeRideCardImg : this.EbikeRideCardImg;
      }
      // 根据tabCode返回对应的卡片图片
      return this.tabCode === 'bike' ? this.BikeRideCardImg : this.EbikeRideCardImg;
    },
    getAmount(val, key) {
      if (this.propertyDetailDTOS && this.propertyDetailDTOS[val]) {
        return this.propertyDetailDTOS[val][key];
      }
      return '';
    },
    scrollAnimate() {
      setTimeout(() => {
        this.$nextTick(() => {
          const newItems = [...this.propertyDetailDTOS];
          newItems.push(newItems.shift());
          this.propertyDetailDTOS = newItems;
          this.isAnimating = false;
        });
      }, 2900);
    },
    buyMember() {
      UBT.clickButton({
        pageId: 'platform_openedcard_page',
        buttonName: 'platform_buyVIP_button',
        categoryId: 'platform',
        businessInfo: {},
      });
      let link = window.location.href;
      link = ParamsUtil.removeParams(link, 'adsource');
      link = ParamsUtil.addParams(link, { adsource: this.tabCode === 'bike' ? 'biketab' : 'ebiketab' });
      window.location.replace(link);
      getNoScroll(true);
      this.moduleData.current = this.moduleData.price;
      this.moduleData.original = this.moduleData.markedPrice;
      this.$emit('buyMember', this.moduleData);
    },
    showSmallMoney() {
      if (this.moduleData.signInfoDTO
        && this.moduleData.signInfoDTO.firstSignPrice > this.rideMoneyData
        && this.rideMoneyData) {
        this.differenceMoney = parseFloat(
          (this.moduleData.signInfoDTO.firstSignPrice - this.rideMoneyData).toFixed(2),
        );
        return true;
      }
      return false;
    },
    showBigMoney() {
      if (this.moduleData.signInfoDTO.firstSignPrice > this.rideMoneyData) {
        if (this.rideMoneyData) {
          return parseFloat(this.rideMoneyData);
        }
      }
      return parseFloat(this.moduleData.signInfoDTO.firstSignPrice);
    },
  },
};
</script>
<style lang="less" scoped>
.member-block {
  width: 3.51rem;
  border-radius: 0.16rem;
  margin: 0 0.12rem;
  background: linear-gradient(93.89deg, #fff0b9 2.27%, #fffbee 98.26%);
  padding: 0.08rem 0.15rem 0.04rem 0.04rem;
  display: flex;
  justify-content: space-between;

  .member-left {
    .member-title {
      margin-left: 0.1rem;
      margin-top: 0.04rem;
      height: 0.14rem;
      margin-bottom: 0.1rem;

      img {
        height: 0.14rem;
      }
    }
  }

  .member-right {
    .member-top-right {
      .member-top-right-word {
        display: flex;
        justify-content: flex-end;
        flex-wrap: nowrap;

        .bule-big-word {
          margin-left: 0.02rem;
          font-family: "DIN Alternate Bold", sans-serif;
          font-size: 0.2rem;
          font-weight: 700;
          line-height: 0.2442rem;
          text-align: right;
          color: #08f;
          white-space: nowrap;
          overflow: visible;
        }

        .blue-small-word {
          margin-top: 0.07rem;
          font-family: "PingFang SC", sans-serif;
          font-size: 0.1rem;
          font-weight: 500;
          line-height: 0.168rem;
          color: #08f;
          white-space: nowrap;
          overflow: visible;
        }
      }

      .line-word {
        font-family: "PingFang SC", sans-serif;
        font-size: 0.12rem;
        font-weight: 400;
        line-height: 0.168rem;
        text-decoration: line-through;
        color: #bcc4cc;
        text-align: right;
      }

      .member-top-right-btn {
        float: right;
        width: 0.5rem;
        height: 0.21rem;
        background: #08f;
        color: #fff;
        line-height: 0.21rem;
        text-align: center;
        border-radius: 0.5rem;
        margin-top: 0.2rem;
        font-size: 0.12rem;
      }
    }
  }

  .member-info {
    border-radius: 0.16rem;
    height: 0.58rem;
    display: flex;
    flex-wrap: nowrap;

    .member-top {
      width: 1.47rem;
      border: 0.01rem solid #ffedc4;
      height: 0.58rem;
      border-radius: 0.12rem;
      position: relative;
      background: #fff;
      padding-top: 0.09rem;
      padding-left: 0.1rem;

      .member-top-left {
        .member-top-left-title {
          font-family: "PingFang SC", sans-serif;
          font-size: 0.14rem;
          font-weight: 500;
          color: #242729;
        }

        .member-top-left-word {
          font-family: "PingFang SC", sans-serif;
          font-size: 0.1rem;
          font-weight: 400;
          line-height: 0.168rem;
          color: #879099;
        }
      }

      .member-plus-img {
        img.plus {
          z-index: 5;
          position: absolute;
          right: -0.09rem;
          top: 0.195rem;
          width: 0.15rem;
          height: 0.15rem;
        }
      }
    }

    .member-middle {
      width: 1.11rem;
      height: 0.57rem;
      border-left: 0.01rem solid #ffedc4;
      border-radius: 0.08rem;
      margin-left: 0.04rem;
      position: relative;

      .member-animate {
        border-radius: 0.08rem;
        width: 0.52rem;
        height: 0.57rem;
        border: 0.01rem solid #ffedc4;
        background: #fff;
        animation: slide 12s calc(~"-3s * var(--i)") infinite;
        -webkit-animation: slide 12s calc(-3s * var(--i)) infinite;

        /* Safari */
        -moz-animation: slide 12s calc(-3s * var(--i)) infinite;

        /* Firefox */
        -o-animation: slide 12s calc(-3s * var(--i)) infinite;

        /* Opera */
        animation-delay: calc(-3s * var(--i));
        position: absolute;
        bottom: 0;
        right: 0;
        z-index: 1;
      }

      .member-animate {
        animation: slide 12s infinite;
      }

      @keyframes slide {
        0%,
        100% {
          z-index: 1;
          transform: translateX(0);
          opacity: 1;
        }

        8.33%,
        25% {
          z-index: 2;
          transform: translateX(-0.1rem);
          opacity: 1;
        }

        33.33%,
        50% {
          z-index: 3;
          transform: translateX(-0.2rem);
          opacity: 1;
        }

        58.33%,
        75% {
          z-index: 4;
          transform: translateX(-0.61rem);
          opacity: 1;
        }

        78% {
          z-index: 0;
          transform: translateX(-0.61rem);
          opacity: 0.2;
        }

        78.1% {
          transform: translateX(0);
          opacity: 0.5;
        }
      }

      .member-list-code {
        background: #fffae8;
        width: 0.52rem;
        border-radius: 0.08rem;
      }
    }
  }
}

.top-word {
  display: flex;
  justify-content: center;
  padding-top: 0.06rem;

  .big-word {
    font-family: "DIN Alternate Bold", sans-serif;
    font-size: 0.24rem;
    font-weight: 700;
    line-height: 0.2794rem;
    color: #fa4614;
  }

  .small-word {
    font-family: PingFang SC, sans-serif;
    font-size: 0.1rem;
    font-weight: 400;
    line-height: 0.14rem;
    margin-top: 0.11rem;
    color: #fa4614;
  }
}

.bottom-word {
  color: #531900;
  font-family: PingFang SC, sans-serif;
  font-size: 0.1rem;
  font-weight: 500;
  line-height: 0.14rem;
  margin: 0 auto;
  text-align: center;
}
</style>
